import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ImageHttps',
  standalone: false
})

export class ImageHttpsPipe implements PipeTransform {
  transform(value: string): string {
    return value && !value?.includes('https') ? value.toLocaleLowerCase().replace('http', 'https') : value;
  }
}
